exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-control input.text-input{max-width:7em;flex:1}", ""]);

// exports
